import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'array',
            empty: false,
            mandatory: true
        };
    }
}
